import React from "react";
import {
  Card,
  Row,
  Col,
  Input,
  Table,
  Modal,
  Divider,
  Typography,
  message,
} from "antd";
import {
  CarOutlined,
  SearchOutlined,
  EyeOutlined,
  IdcardOutlined,
  UserOutlined,
} from "@ant-design/icons";

import Config from "../../Config";
import { connect } from "react-redux";
import {
  initHandler,
  ajaxViewHandler,
  ajaxHandler,
  setConfig,
  extractResult,
} from "../../store/actions";
import { Helmet } from "react-helmet";
import { RoundedInput, RoundedButton } from "../../components/RoundedComponents";

const { Text } = Typography;

const configClass = {
  title: "Cari Kendaraan",
  apiUrl: {
    cari: "kendaraan/api/cari-kendaraan/",
  },
  breadCrumb: [
    <span>
      <CarOutlined /> Informasi
    </span>,
    "Cari Kendaraan",
  ],
};

const config = new Config();

class FormCariKendaraan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      q: "",
      loadingData: false,
      dataSource: [],
      pagination: { current: 1, pageSize: 25, total: 0 },
      hasSearched: false,

      visibleModal: false,
      dataDetail: null,

      columns: [
        {
          title: "Nomor Polisi",
          dataIndex: "nomor_polisi",
          key: "nomor_polisi",
          width: 130,
          render: val => <span style={{ fontFamily: "monospace", fontWeight: 600, color: "#1e4d8a" }}>{val || "-"}</span>,
        },
        {
          title: "Nama Pemilik",
          dataIndex: "nama_wp",
          key: "nama_wp",
          width: 180,
        },
        {
          title: "Alamat",
          dataIndex: "alamat_wp",
          key: "alamat_wp",
          width: 260,
          ellipsis: true,
        },
        {
          title: "Merek",
          dataIndex: "merek_nama",
          key: "merek_nama",
          width: 120,
        },
        {
          title: "Tipe",
          dataIndex: "tipe_nama",
          key: "tipe_nama",
          width: 160,
        },
        {
          title: "Tahun Buat",
          dataIndex: "tahun_buat",
          key: "tahun_buat",
          width: 100,
          align: "center",
        },
        {
          title: "Nomor Rangka",
          dataIndex: "nomor_rangka",
          key: "nomor_rangka",
          width: 170,
          render: val => <span style={{ fontFamily: "monospace", fontSize: 12 }}>{val || "-"}</span>,
        },
        {
          title: "Nomor Mesin",
          dataIndex: "nomor_mesin",
          key: "nomor_mesin",
          width: 150,
          render: val => <span style={{ fontFamily: "monospace", fontSize: 12 }}>{val || "-"}</span>,
        },
        {
          title: "Aksi",
          key: "aksi",
          width: 70,
          fixed: "right",
          align: "center",
          render: (_, row) => (
            <RoundedButton
              title="Detail"
              size="small"
              shape="circle"
              type="primary"
              style={{ background: "linear-gradient(135deg, #0f2847, #1e4d8a)", border: "none" }}
              onClick={() => this.setState({ visibleModal: true, dataDetail: row })}
            >
              <EyeOutlined />
            </RoundedButton>
          ),
        },
      ],
    };
  }

  UNSAFE_componentWillMount() {
    this.props.initHandler();
  }

  cariKendaraan = (page = 1) => {
    const q = (this.state.q || "").trim();
    if (q.length < 3) {
      message.warning("Kata kunci pencarian minimal 3 karakter");
      return;
    }

    const pageSize = this.state.pagination.pageSize;
    const offset = (page - 1) * pageSize;

    this.setState({ loadingData: true, hasSearched: true });
    this.props
      .ajaxViewHandler(
        "get",
        configClass.apiUrl.cari + "?q=" + encodeURIComponent(q) + "&limit=" + pageSize + "&offset=" + offset
      )
      .then((action) => {
        const { isSuccess, responseMsg: data } = extractResult(action);
        if (isSuccess) {
          this.setState({
            dataSource: Array.isArray(data.results) ? data.results : [],
            pagination: { ...this.state.pagination, current: page, total: data.count || 0 },
          });
        } else {
          this.setState({ dataSource: [], pagination: { ...this.state.pagination, current: 1, total: 0 } });
          message.error({ content: (data && data.detail) || "Gagal mencari data kendaraan", duration: 2, key: "toast" });
        }
        this.setState({ loadingData: false });
      })
      .catch(() => {
        this.setState({ loadingData: false });
        message.error({ content: "Gagal request data, coba lagi", duration: 2, key: "toast" });
      });
  };

  handleTableChange = (pagination) => {
    this.setState({ pagination: { ...this.state.pagination, pageSize: pagination.pageSize } }, () => {
      this.cariKendaraan(pagination.current);
    });
  };

  render() {
    return (
      <>
        <div>
          <Helmet>
            <title>
              {configClass.title + " | " + config.get_site_info().name}
            </title>
          </Helmet>
          <div className="card" id="panel-transaksi">
            <Card className="konten" title={null}>

              {/* Search Bar */}
              <Row>
                <Col span={24}>
                  <Input.Group compact style={{ display: "flex" }}>
                    <RoundedInput
                      height="28"
                      autoFocus
                      allowClear
                      style={{ flex: 1 }}
                      placeholder="Cari berdasarkan nama, alamat, nomor rangka, atau nomor mesin (min. 3 karakter)"
                      value={this.state.q}
                      size="large"
                      onChange={(e) => this.setState({ q: e.target.value })}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          this.cariKendaraan(1);
                        }
                      }}
                    />
                    <RoundedButton
                      type="primary"
                      size="large"
                      style={{ width: 90 }}
                      loading={this.state.loadingData}
                      icon={<SearchOutlined />}
                      onClick={() => this.cariKendaraan(1)}
                    >
                      Cari
                    </RoundedButton>
                  </Input.Group>
                </Col>
              </Row>

              {/* Hasil Pencarian */}
              {this.state.hasSearched && (
                <div style={{ marginTop: 16, borderRadius: 12, overflow: "hidden", border: "1px solid #f0f0f0" }}>
                  <Table
                    columns={this.state.columns}
                    dataSource={this.state.dataSource}
                    loading={this.state.loadingData}
                    rowKey="id"
                    size="middle"
                    scroll={{ x: 1240 }}
                    pagination={{
                      current: this.state.pagination.current,
                      pageSize: this.state.pagination.pageSize,
                      total: this.state.pagination.total,
                      showSizeChanger: true,
                      pageSizeOptions: ["25", "50", "100"],
                      showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} kendaraan`,
                    }}
                    onChange={this.handleTableChange}
                  />
                </div>
              )}

            </Card>
          </div>
        </div>

        {/* Modal Detail */}
        <Modal
          title={
            <span>
              <IdcardOutlined style={{ marginRight: 8, color: "#1e4d8a" }} />
              Detail Kendaraan
            </span>
          }
          centered
          visible={this.state.visibleModal}
          onCancel={() => this.setState({ visibleModal: false })}
          width={520}
          footer={[]}
          bodyStyle={{ padding: 0 }}
        >
          {this.state.dataDetail && (() => {
            const p = this.state.dataDetail;
            const row = (label, value, key) => (
              <div key={key || label} style={{ display: "flex", justifyContent: "space-between", gap: 12, padding: "7px 0", borderBottom: "1px solid #f5f5f5" }}>
                <Text type="secondary" style={{ fontSize: 12, flexShrink: 0 }}>{label}</Text>
                <Text style={{ fontSize: 12, fontWeight: 500, textAlign: "right", wordBreak: "break-word" }}>{value || "-"}</Text>
              </div>
            );
            return (
              <div>
                <div style={{
                  background: "linear-gradient(135deg, #0f2847, #1e4d8a)",
                  padding: "18px 22px",
                  display: "flex", alignItems: "center", gap: 14,
                }}>
                  <div style={{
                    width: 46, height: 46, borderRadius: 12,
                    background: "rgba(255,255,255,0.15)",
                    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                  }}>
                    <UserOutlined style={{ color: "#fff", fontSize: 20 }} />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ color: "#fff", fontWeight: 700, fontSize: 16, lineHeight: 1.3 }}>
                      {p.nama_wp || "-"}
                    </div>
                    <div style={{ color: "rgba(255,255,255,0.7)", fontSize: 12, marginTop: 2, fontFamily: "monospace" }}>
                      {p.nomor_polisi || "-"}
                    </div>
                  </div>
                </div>
                <div style={{ padding: "16px 22px" }}>
                  {row("NIK", p.pemilik_nik)}
                  {row("Alamat", p.alamat_wp)}
                  {row("No HP", p.pemilik_no_hp)}

                  <Divider style={{ margin: "10px 0" }} />

                  {row("Merek", p.merek_nama)}
                  {row("Tipe", p.tipe_nama)}
                  {row("Tahun Buat", p.tahun_buat)}
                  {row("Nomor Rangka", p.nomor_rangka)}
                  {row("Nomor Mesin", p.nomor_mesin)}
                </div>
              </div>
            );
          })()}
        </Modal>
      </>
    );
  }
}

const mapStateToProps = function (state) {
  return state.configReducers;
};

export default connect(mapStateToProps, {
  initHandler,
  ajaxViewHandler,
  ajaxHandler,
  setConfig,
})(FormCariKendaraan);
